module.exports = __webpack_public_path__ + "images/icons_v2/referral-outlined-031c344e.svg";